module.exports = __webpack_public_path__ + "static/media/cr.b0b2c41b.webp";